import React from 'react';
import { CircularProgress } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import { formatTime } from '../utils';
import styles from './MessageBubble.module.css';

// Conteúdo da mensagem conforme o tipo (texto, imagem, áudio, vídeo, documento)
const MessageContent = ({ msg }) => {
  const type = (msg.messageType || 'text').toLowerCase();

  if ((type === 'image' || type === 'sticker') && msg.mediaUrl) {
    return (
      <>
        <a href={msg.mediaUrl} target="_blank" rel="noreferrer">
          <img
            src={msg.mediaUrl}
            alt={msg.caption || 'Imagem'}
            className={type === 'sticker' ? styles.sticker : styles.image}
          />
        </a>
        {msg.caption && <p className={styles.caption}>{msg.caption}</p>}
      </>
    );
  }

  if (type === 'audio' && msg.mediaUrl) {
    return <audio controls src={msg.mediaUrl} className={styles.audio} />;
  }

  if (type === 'video' && msg.mediaUrl) {
    return (
      <>
        <video controls src={msg.mediaUrl} className={styles.video} />
        {msg.caption && <p className={styles.caption}>{msg.caption}</p>}
      </>
    );
  }

  if (type === 'document' && msg.mediaUrl) {
    return (
      <a href={msg.mediaUrl} target="_blank" rel="noreferrer" className={styles.documentLink}>
        <InsertDriveFileOutlinedIcon className={styles.documentIcon} />
        {msg.fileName || 'Documento'}
      </a>
    );
  }

  // Texto (ou mídia antiga cuja URL não foi salva)
  return (msg.messageText || msg.caption || '').split(/\r?\n|\\n/).map((line, i) => (
    <p key={i} className={styles.textLine}>{line || ' '}</p>
  ));
};

// Ícone de status para mensagens enviadas pelo painel
const StatusIndicator = ({ status }) => {
  if (status === 'sending') return <CircularProgress size={10} thickness={6} className={styles.statusIcon} />;
  if (status === 'failed') return <ErrorOutlineIcon className={`${styles.statusIcon} ${styles.statusFailed}`} />;
  // 'sent' (ou mensagem vinda do servidor)
  return <CheckIcon className={styles.statusIcon} />;
};

/**
 * Balão de mensagem. Enviadas à direita (azul claro), recebidas à
 * esquerda (branco). Mensagens que falharam mostram "Tentar novamente".
 */
const MessageBubble = ({ msg, onRetry, onDiscard }) => {
  const isSent = msg.direction === 'sent';
  const failed = msg.sendStatus === 'failed';

  return (
    <div className={`${styles.row} ${isSent ? styles.rowSent : styles.rowReceived}`}>
      <div className={`${styles.bubble} ${isSent ? styles.bubbleSent : styles.bubbleReceived} ${failed ? styles.bubbleFailed : ''}`}>
        <div className={styles.content}>
          <MessageContent msg={msg} />
        </div>
        <div className={styles.footer}>
          <span className={styles.time}>{formatTime(msg.date)}</span>
          {isSent && <StatusIndicator status={msg.sendStatus || 'sent'} />}
        </div>
        {failed && (
          <div className={styles.failedActions}>
            <span className={styles.failedText}>Não enviada.</span>
            <button className={styles.retryButton} onClick={() => onRetry(msg.messageId)}>
              Tentar novamente
            </button>
            <button className={styles.discardButton} onClick={() => onDiscard(msg.messageId)}>
              Descartar
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default MessageBubble;
